import { render, staticRenderFns } from "./TokenInfo.vue?vue&type=template&id=b7beaad8&"
import script from "./TokenInfo.vue?vue&type=script&lang=js&"
export * from "./TokenInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports